/* Preserve the visitor's context for Jotform; no Meta events are sent here. */
(function () {
  'use strict';

  var mount = document.currentScript && document.currentScript.parentElement;
  if (!mount || mount.getAttribute('data-meta-jotform') !== '260474728214054' ||
      mount.getAttribute('data-meta-jotform-loaded') === 'true') return;
  mount.setAttribute('data-meta-jotform-loaded', 'true');

  var formId = '260474728214054';
  var storageKey = 'bh_meta_jotform_fbc_v1';
  var eventIdKey = 'bh_meta_event_id_v1';
  var now = Date.now();
  // Ad URL templates sometimes ship the literal placeholder (fbclid=fbclid): it is not a click.
  var placeholder = /^(undefined|null|test|test_fbclid.*|fbclid)$/i;
  var fields = {
    meta_fbc: '',
    meta_fbp: '',
    meta_client_user_agent: '',
    meta_context_captured_at: '',
    meta_context_source: ''
  };

  function cookie(name) {
    try {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var pair = cookies[i].trim();
        if (pair.indexOf(name + '=') === 0) return decodeURIComponent(pair.slice(name.length + 1));
      }
    } catch (error) { /* A blocked or malformed cookie means no identifier. */ }
    return '';
  }

  function clickId() {
    var query = window.location.search.slice(1).split('&');
    for (var i = 0; i < query.length; i++) {
      try {
        var parts = query[i].split('=');
        if (decodeURIComponent(parts.shift()) === 'fbclid') {
          var value = decodeURIComponent(parts.join('=').replace(/\+/g, ' '));
          return /^[A-Za-z0-9_-]{1,2048}$/.test(value) && !placeholder.test(value) ? value : '';
        }
      } catch (error) { /* Skip a malformed pair; never invent a click ID from it. */ }
    }
    return '';
  }

  // Meta wants the original value: the cookie's own timestamp is kept whatever its age.
  function validFbc(value) {
    var match = /^fb\.([0-9]+)\.([0-9]{13})\.([A-Za-z0-9_-]{1,2048})$/.exec(value || '');
    return !!match && !placeholder.test(match[3]);
  }

  function validFbp(value) {
    return /^fb\.[0-9]+\.[0-9]{13}\.[0-9]+$/.test(value || '');
  }

  // A visitor from an instant form follow-up link (fbclid=fbclid) is already a lead whose CompleteRegistration the server sent at lead creation, so a browser one would count them twice.
  function fromInstantFormFollowUp() {
    return /(^|[?&])fbclid=fbclid(&|$)/i.test(window.location.search);
  }

  // Same format the Meta pixel writes (fb.<domain index>.<creation ms>.<random>), so the pixel keeps this cookie.
  function createFbp() {
    var value = 'fb.1.' + now + '.' + Math.floor(Math.random() * 2147483647);
    var base = '_fbp=' + value + '; path=/; max-age=7776000; SameSite=Lax';
    try {
      document.cookie = base + '; domain=.' + window.location.hostname.split('.').slice(-2).join('.');
      if (cookie('_fbp') !== value) document.cookie = base;
    } catch (error) { return ''; }
    return cookie('_fbp') === value ? value : '';
  }

  // jsform copies the address after its first '?' into the form: only plain names and a plain anchor may pass, so the capture fields keep the last word.
  function dropCaptureParameters() {
    try {
      var href = window.location.href;
      var hashAt = href.indexOf('#');
      var base = hashAt < 0 ? href : href.slice(0, hashAt);
      var hash = hashAt < 0 ? '' : href.slice(hashAt);
      if (!/^#[\w-]*$/.test(hash)) hash = '';
      var start = base.indexOf('?');
      var pieces = start < 0 ? [] : base.slice(start + 1).split('&');
      var kept = pieces.filter(function (piece) {
        var name = piece.split('=')[0];
        // jsform decodes every value without a catch, so one malformed escape would stop the form from rendering.
        try {
          name = decodeURIComponent(name);
          decodeURIComponent(piece.slice(piece.indexOf('=') + 1));
        } catch (error) { return false; }
        return /^[\w.-]*$/.test(name) && !/meta|(^|_)(fbc|fbp|user_agent|captured_at|context_source)$/i.test(name);
      });
      var clean = (start < 0 ? base : base.slice(0, kept.length ? start + 1 : start) + kept.join('&')) + hash;
      if (clean !== href) window.history.replaceState(window.history.state, '', clean);
    } catch (error) { /* The form must load even if the address cannot be rewritten. */ }
  }

  function consentAllowsCapture() {
    try {
      var consent = window.Osano.cm.getConsent();
      return consent.MARKETING === 'ACCEPT' && consent.OPT_OUT !== 'ACCEPT' &&
        navigator.globalPrivacyControl !== true;
    } catch (error) { return false; }
  }

  try {
    if (consentAllowsCapture()) {
      var fbclid = clickId();
      var fbc = cookie('_fbc');
      var savedFbc = '';
      try { savedFbc = window.sessionStorage.getItem(storageKey) || ''; } catch (error) {}
      if (fbclid) {
        if (!validFbc(fbc) || fbc.split('.').slice(3).join('.') !== fbclid) {
          fbc = validFbc(savedFbc) && savedFbc.split('.').slice(3).join('.') === fbclid ?
            savedFbc : 'fb.1.' + now + '.' + fbclid;
        }
      } else if (!validFbc(fbc)) {
        fbc = validFbc(savedFbc) ? savedFbc : '';
      }
      if (!validFbc(fbc)) fbc = '';
      if (fbc) {
        try { window.sessionStorage.setItem(storageKey, fbc); } catch (error) {}
      }
      // On a first visit the pixel has not written its browser ID yet, so the form would leave without one; a value we cannot read is left untouched.
      var existingFbp = cookie('_fbp');
      var fbp = validFbp(existingFbp) ? existingFbp : (existingFbp ? '' : createFbp());
      fields.meta_fbc = fbc;
      fields.meta_fbp = fbp;
      fields.meta_client_user_agent = navigator.userAgent || '';
      fields.meta_context_captured_at = new Date(now).toISOString();
      fields.meta_context_source = 'website_jotform';
      // The thank-you page sends CompleteRegistration with this ID, the value the server event carries too.
      try {
        if (fbp && !fromInstantFormFollowUp()) window.sessionStorage.setItem(eventIdKey, fbp);
        else window.sessionStorage.removeItem(eventIdKey);
      } catch (error) {}
    } else {
      try {
        window.sessionStorage.removeItem(storageKey);
        window.sessionStorage.removeItem(eventIdKey);
      } catch (error) {}
    }
  } catch (error) { /* Capture failure must not stop the intake form. */ }

  dropCaptureParameters();

  // Pass the capture fields to Jotform, including explicit empty values when capture is unavailable.
  var query = Object.keys(fields).map(function (name) {
    return encodeURIComponent(name) + '=' + encodeURIComponent(fields[name]);
  }).join('&');
  var embed = document.createElement('script');
  embed.type = 'text/javascript';
  embed.src = 'https://form.jotform.com/jsform/' + formId + '?' + query;
  mount.appendChild(embed);
})();
